import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      selectedFilters: state => state.globalCMP.selectedFilters,
    }),
    ...mapGetters(['getBackendConfig']),
    hierarchicalConfig() {
      return {
        personalDataFields: {
          params: {
            platform: 'backoffice',
            enrollment: 'false',
            lookup: 'personal_data_fields',
          },
        },
      }
    },
  },
  methods: {
    ...mapActions(['setBackendConfig']),
    async loadMemberPersonalDataFieldsConfig(payload) {
      payload = { ...this.hierarchicalConfig.personalDataFields.params, ...payload }
      await this.setBackendConfig(this.$helpers.makeQueryString(payload))
    },
    getMemberPersonalDataFieldsConfig(fieldName) {
      let result = { required: true, display: true }
      let config = this.getBackendConfig('personal_data_fields', 'normalized_value') || []
      if (config.fields && config.fields.length > 0) {
        let fieldConfig = config.fields.find(x => x.key === fieldName)
        if (fieldConfig) {
          return ({ result } = fieldConfig)
        }
      }
      return result
    },
  },
}
